import { Campaign, CampaignFormValues } from '@/client/campaigns';
import { EmailTemplateStep } from '@/components/campaigns/forms/EmailTemplateStep';
import { PageTemplateStep } from '@/components/campaigns/forms/PageTemplateStep';
import { PeriodStep } from '@/components/campaigns/forms/PeriodStep';
import { SenderProfileStep } from '@/components/campaigns/forms/SenderProfileStep';
import { TargetGroupStep } from '@/components/campaigns/forms/TargetGroupStep';
import { FormikErrors } from 'formik';
import React from 'react';
import { InfoStep } from './InfoStep';

type CampaignWizardStepsProps = {
  initialValues: CampaignFormValues;
  activeStep: number;
  values: CampaignFormValues;
  errors: FormikErrors<CampaignFormValues>;
  setFieldValue: (field: string, value: any) => void;
  campaignId?: string;
  exitPrompt?: boolean;
  isTemplate?: boolean;
  campaign?: Campaign;
};

export const CampaignWizardSteps: React.FC<CampaignWizardStepsProps> = ({
  initialValues,
  activeStep,
  values,
  errors,
  setFieldValue,
  campaignId,
  exitPrompt,
  isTemplate,
  campaign,
}) => {
  const step = () => {
    switch (activeStep) {
      case 0:
        return (
          <EmailTemplateStep
            values={values}
            valuesSetter={setFieldValue}
            exitPrompt={exitPrompt}
            preselectedEmailTempId={initialValues.emailTemplate}
          />
        );
      case 1:
        return (
          <PageTemplateStep
            values={values}
            valuesSetter={setFieldValue}
            exitPrompt={exitPrompt}
            preselectedPageTempId={initialValues.landingPage}
          />
        );
      case 2:
        return (
          <SenderProfileStep
            values={values}
            valuesSetter={setFieldValue}
            exitPrompt={exitPrompt}
            preselectedSenderProfileId={initialValues.sendingProfile?.id}
          />
        );
      case 3:
        return isTemplate ? (
          <InfoStep
            values={values}
            valuesSetter={setFieldValue}
            errors={errors}
            preselectedThumbnail={
              campaign?.masterTemplate?.thumbnail ?? campaign?.thumbnail ?? null
            }
            campaign={campaign}
          />
        ) : (
          <TargetGroupStep values={values} valuesSetter={setFieldValue} />
        );
      case 4:
        return (
          <PeriodStep
            initialValues={initialValues}
            values={values}
            valuesSetter={setFieldValue}
            campaignId={campaignId}
          />
        );
      default:
        return null;
    }
  };

  return step();
};
